export const roles = {
    systemAdmin: "System Admin",
    admin: "Admin",
    cpoGroup: "Partner",
    cpoAdmin: "CPO Admin",
    cpoMonitor: "CPO Monitor",
    retailer: "Retailer",
    user: "User",
    socketMonitor: "Socket Monitor"
}
